import { IconComponent } from '@adaptiva/widgets/icon';
import { ChangeDetectionStrategy, Component, input, InputSignal, output, OutputEmitterRef } from '@angular/core';

@Component({
	selector: '[ada-suggested-prompts]',
	templateUrl: './suggested-prompts.component.html',
	styleUrl: './suggested-prompts.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [IconComponent]
})
export class SuggestedPromptsComponent {

	public readonly suggestions: InputSignal<string[]> = input([]);

	public readonly isDisabled: InputSignal<boolean> = input(false);

	public readonly selected: OutputEmitterRef<string> = output();

}
